var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrowWithBackground = function SvgBackArrowWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000929",
    fillRule: "evenodd",
    d: "M27.933 20c0 .265-.104.52-.29.707a1 1 0 0 1-.701.293H15.453l4.258 4.291a1 1 0 0 1 .215 1.091 1 1 0 0 1-.537.542.99.99 0 0 1-1.082-.217l-5.95-6a1 1 0 0 1-.215-1.09q.076-.184.216-.325l5.949-5.999a.99.99 0 0 1 1.404 0 1.005 1.005 0 0 1 0 1.416L15.453 19h11.489c.262 0 .515.105.7.293.187.188.291.442.291.707",
    clipRule: "evenodd"
  })));
};
export default SvgBackArrowWithBackground;